import { getLocalStorageObject, setLocalStorageObject } from '@xyo-network/sdk-xyo-react-js';
import { OfferValue } from '../../models';
import { CartItems, cartItemsNfc } from './CartItems';
import CartItemSet from './CartItemSet';
import CartItemSlot from './CartItemSlot';
import DiscountCodes from './DiscountCodes';
export class Cart {
    constructor() {
        this.items = new Map();
        this.upgrades = () => {
            var _a;
            const map = new Map();
            return (_a = map.get(this.getItemSet())) !== null && _a !== void 0 ? _a : [];
        };
        this.data = {};
        this.load();
        this.updateTotals();
        this.updateShipping();
    }
    static defaultItems() {
        return cartItemsNfc;
    }
    getItemSet() {
        var _a;
        return (this.data.itemSet = (_a = this.data.itemSet) !== null && _a !== void 0 ? _a : CartItemSet.Nfc);
    }
    save() {
        setLocalStorageObject('cartInfo', this.data);
    }
    load() {
        const data = getLocalStorageObject('cartInfo');
        if (!(data === null || data === void 0 ? void 0 : data.itemSet) || !CartItems.get(data === null || data === void 0 ? void 0 : data.itemSet)) {
            this.clear();
        }
        else {
            this.data = data;
        }
        if (this.items.size === 0) {
            this.loadDefaultItems();
        }
        return this.data.itemSet;
    }
    refreshDataItems() {
        this.data.items = Array.from(this.items.values());
    }
    loadDefaultItems() {
        var _a;
        const values = (_a = this.getSetItems()) === null || _a === void 0 ? void 0 : _a.entries();
        if (values) {
            Array.from(values).map((entry) => {
                if (entry[1].defaultAdd) {
                    this.addItem(entry[0]);
                }
            });
        }
        return this;
    }
    clear() {
        localStorage.removeItem('cartInfo');
        this.data = {};
    }
    updateTotals() {
        this.data.margin = this.getMargin();
        this.data.total = this.getTotal();
        this.data.value = this.getValue();
    }
    updateOffer(offerToUse) {
        const offer = offerToUse !== null && offerToUse !== void 0 ? offerToUse : OfferValue.Trial;
        this.removeItem(CartItemSlot.Subscription);
        this.removeItem(CartItemSlot.Trial);
        this.removeItem(CartItemSlot.SemiAnnual);
        switch (offer) {
            case OfferValue.Subscription:
                this.addItem(CartItemSlot.Subscription);
                break;
            case OfferValue.Trial:
                this.addItem(CartItemSlot.Trial);
                break;
            case OfferValue.SemiAnnual:
                this.addItem(CartItemSlot.SemiAnnual);
                break;
            case OfferValue.None:
                break;
            default:
                this.addItem(CartItemSlot.Trial);
                break;
        }
        this.updateTotals();
        this.save();
    }
    selectSet(cartItemSet, reload) {
        if (reload) {
            this.clear();
            this.data.itemSet = cartItemSet;
            this.loadDefaultItems();
            this.save();
        }
        else {
            this.data.itemSet = cartItemSet;
        }
    }
    getSetItems() {
        var _a;
        return (_a = CartItems.get(this.getItemSet())) !== null && _a !== void 0 ? _a : Cart.defaultItems();
    }
    getItemsBySlot(slot) {
        return this.items.get(slot);
    }
    getItems() {
        return this.data.items;
    }
    shippingRequired() {
        return this.itemsToShip().length > 0;
    }
    updateShipping(country = 'US') {
        if (this.shippingRequired()) {
            this.removeItem(CartItemSlot.ShippingIntl);
            this.removeItem(CartItemSlot.Shipping);
            if (country === 'US') {
                this.removeItem(CartItemSlot.ShippingIntl);
                this.removeItem(CartItemSlot.Shipping);
                this.addItem(CartItemSlot.Shipping);
            }
            else {
                this.removeItem(CartItemSlot.Shipping);
                this.removeItem(CartItemSlot.ShippingIntl);
                this.addItem(CartItemSlot.ShippingIntl);
            }
            this.save();
        }
    }
    itemsToShip() {
        var _a;
        return ((_a = this.getItems()) !== null && _a !== void 0 ? _a : []).filter((item) => item.ship);
    }
    getShipping() {
        const domestic = this.items.get(CartItemSlot.Shipping);
        const intl = this.items.get(CartItemSlot.ShippingIntl);
        if (domestic && intl) {
            throw Error('Double Shipping Selected');
        }
        return domestic !== null && domestic !== void 0 ? domestic : intl;
    }
    setDiscount(code) {
        if (code) {
            this.data.discountCode = DiscountCodes.get(code);
        }
        else {
            this.data.discountCode = undefined;
        }
    }
    addItem(slot) {
        const itemSet = CartItems.get(this.getItemSet());
        if (itemSet) {
            const item = itemSet.get(slot);
            if (item) {
                this.items.set(slot, item);
                if (item.defaultDiscount) {
                    this.setDiscount(item.defaultDiscount);
                }
            }
            else {
                throw Error('addItem: Item missing from set');
            }
        }
        else {
            throw Error('addItem: No set selected');
        }
        this.refreshDataItems();
        this.updateTotals();
    }
    removeItem(slot) {
        this.items.delete(slot);
        this.refreshDataItems();
        this.updateTotals();
    }
    getTotal() {
        var _a;
        this.data.total = 0;
        for (const item of (_a = this.getItems()) !== null && _a !== void 0 ? _a : []) {
            this.data.total = this.data.total + item.price;
        }
        this.data.total = this.data.total + this.getDiscountAmount();
        this.data.total = Math.ceil(this.data.total * (1 + this.getDiscountPercent()) * 100) / 100;
        return this.data.total;
    }
    getMsrp() {
        var _a, _b;
        this.data.msrp = 0;
        for (const item of (_a = this.getItems()) !== null && _a !== void 0 ? _a : []) {
            this.data.msrp = this.data.msrp + ((_b = item.msrp) !== null && _b !== void 0 ? _b : 0);
        }
        return this.data.msrp;
    }
    getSavingsPercent() {
        const msrp = this.getMsrp();
        const total = this.getTotal();
        if (msrp === 0)
            return 0;
        return 1 - total / msrp;
    }
    getMargin() {
        var _a;
        this.data.margin = 0;
        for (const item of (_a = this.getItems()) !== null && _a !== void 0 ? _a : []) {
            this.data.margin = this.data.margin + item.price - item.COGS;
        }
        this.data.margin = this.data.margin + this.getDiscountAmount();
        this.data.margin = Math.ceil(this.data.margin * (1 + this.getDiscountPercent()) * 100) / 100;
        return this.data.margin;
    }
    getDiscountAmount() {
        var _a, _b;
        return (_b = (_a = this.data.discountCode) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0;
    }
    getDiscountPercent() {
        var _a, _b;
        return (_b = (_a = this.data.discountCode) === null || _a === void 0 ? void 0 : _a.percent) !== null && _b !== void 0 ? _b : 0;
    }
    getValue() {
        var _a;
        this.data.value = 0;
        for (const item of (_a = this.getItems()) !== null && _a !== void 0 ? _a : []) {
            this.data.value = this.data.value + item.value;
        }
        this.data.value = this.data.value + this.getDiscountAmount();
        this.data.value = Math.ceil(this.data.value * (1 + this.getDiscountPercent()) * 100) / 100;
        return this.data.value;
    }
    static get() {
        var _a;
        this.instance = (_a = this.instance) !== null && _a !== void 0 ? _a : new Cart();
        return this.instance;
    }
}
//# sourceMappingURL=Cart.js.map